import { addToCartEmits, addToCartProps, useAddToCart } from "@/components/organisms/mixins/add-to-cart.mixin";

export const productSheetAddToCartProps = () => ({
  article: {
    type: Object,
    required: false,
    default: null
  },
  quantite: {
    type: Number,
    required: true
  },
  quantiteClickAndCollect: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteDrive: {
    type: Number,
    required: false,
    default: 0
  },
  isBuffet: {
    type: Boolean,
    required: false,
    default: false
  },
  quantiteClickAndCollectTraiteur: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteClickAndCollectTraiteurNoel: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteLdd: {
    type: Number,
    required: false,
    default: 0
  },
  maxCartQty: {
    type: Number,
    required: false
  },
  isPft: {
    type: Boolean,
    required: false
  },
  pftConf: {
    type: [Object, Array],
    required: false,
    default: null
  },
  isClientPro: {
    type: Boolean,
    required: false,
    default: false
  },
  clickAndCollectDuration: {
    type: String,
    required: false,
    default: ""
  },
  ...addToCartProps()
})

export const productSheetAddToCartEmits = () => ([
  "addToCartPft",
  "indexPoidsChanged",
  ...addToCartEmits()
])

export const useProductSheetAddToCart = (props, emit) => {
  const indexPoids = ref(0);

  const {
    setQuantity,
    removeItem,
    showTypeDrive,
    showTypeClickAndCollect,
    showTypeTraiteur,
    showTypeTraiteurNoel,
    isClickAndCollectTraiteurWithoutPro,
    isClickAndCollectTraiteurNoelWithoutPro,
    isDrive,
    isClickAndCollect,
    isClickAndCollectTraiteur,
    isClickAndCollectTraiteurNoel,
    isLdd,
    isLddOnly,
    isNotEligibleClickAndCollect,
    isClickAndCollectOnly,
    isNotEligibleLdd,
    hasMultiplePaniers,
    isCKDO
  } = useAddToCart(props, { emit });

  const addToCartPft = (index) => {
    indexPoids.value = index;
    emit('addToCartPft', index);
  }
  const plageSelected = ({ index, type }) => {
    indexPoids.value = index;
    emit('indexPoidsChanged', { index, type })
  }

  return {
    isCKDO,
    setQuantity,
    removeItem,
    showTypeDrive,
    showTypeClickAndCollect,
    showTypeTraiteur,
    showTypeTraiteurNoel,
    isClickAndCollectTraiteurWithoutPro,
    isClickAndCollectTraiteurNoelWithoutPro,
    isDrive,
    isClickAndCollect,
    isClickAndCollectTraiteur,
    isClickAndCollectTraiteurNoel,
    isLdd,
    isLddOnly,
    isNotEligibleClickAndCollect,
    isClickAndCollectOnly,
    isNotEligibleLdd,
    indexPoids,
    hasMultiplePaniers,
    addToCartPft,
    plageSelected
  }
}